import { render, staticRenderFns } from "./ShopScView.vue?vue&type=template&id=9f279c56&scoped=true&"
import script from "./ShopScView.vue?vue&type=script&lang=js&"
export * from "./ShopScView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f279c56",
  null
  
)

export default component.exports